export const APP_CONFIG_DEFAULTS = {
    supportsChatInput: true,
    supportsVideoInput: true,
    supportsScreenShare: true,
    isPreConnectBufferEnabled: true,
};
export const WIDGET_CONFIG_DEFAULTS = {
    agentDisplayName: 'AI Assistant',
    themeMode: 'dark',
    supportsChatInput: true,
    supportsVideoInput: false,
    supportsScreenShare: false,
    isPreConnectBufferEnabled: true,
    poweredByText: 'Powered by Mazed',
    poweredByUrl: 'https://mazed.ai',
};
